// @flow
import { DropDownMenu } from "common/components/DropDownMenu/DropDownMenu";
import { useField, useFormikContext } from "formik";
import { useEffect, useState } from "react";

type Props = {
  name: string;
  items: { label: string; id: number }[];
  btnTxt: string;
  value?: string;
};
export const FormikInjectedDropDown = ({
  name,
  items,
  btnTxt,
  value,
}: Props) => {
  const [field, meta, helpers] = useField(name);

  const [selectedItem, setSelectedItem] = useState<number>();

  useEffect(() => {
    selectedItem && helpers.setValue("" + selectedItem);
  }, [selectedItem]);

  return (
    <DropDownMenu
      btnTxt={btnTxt}
      items={items}
      setSelectedItem={setSelectedItem}
      value={value}
    />
  );
};
